export default __webpack_public_path__ + "static/media/FACT-1.4e27188a.jpg";